import { Col, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const ContentArea = styled.div`
  display: flex;
  flex-direction: row;
  width: 1140px;
  height: 100%;
  position: relative;

  @media (max-width: 1024px) {
    width: 100vw;
  }
`;

const Wrapper = styled(Col)`
  wid: 100%;
  height: 316px;
  margin: 88px 0 0;
  background-color: ${theme.SECONDARY};
  background-size: cover;

  @media (max-width: 1024px) {
    margin: 26px 0 0;
    height: 308px;
    justify-content: flex-start;
  }

  @media (min-width: 1024px) {
    align-items: center;
  }
`;

const BannerTextImg = styled.img`
  width: 780px;
  top: 58px;
  left: -8px;
  position: absolute;
  z-index: 3;

  @media (max-width: 1024px) {
    top: 140px;
    width: 389px;
    left: 16px;
  }
`;

const BannerTextContainer = styled.div`
  z-index: 3;

  .text-1,
  .text-2,
  .text-3,
  .text-4 {
    font-size: 170px;
    letter-spacing: -13px;
    position: absolute;
  }

  .text-1 {
    top: 44px;
    left: -13px;
  }

  .text-2 {
    top: 174px;
    left: -10px;
  }

  @media (max-width: 1024px) {
    top: 160px;
    width: 99%;

    .text-1,
    .text-2,
    .text-3,
    .text-4 {
      font-size: 80px;
      letter-spacing: -3px;
    }

    .text-1 {
      top: 137px;
      left: 14px;
    }

    .text-2 {
      top: 201px;
      left: 15px;
    }
  }
`;

const TitleText = styled(Text)`
  position: absolute;
  top: -53px;
  left: 0px;

  @media (max-width: 1024px) {
    display: none;
  }
`;

const TeamImg = styled.img`
  height: 381px;
  width: 400px;
  position: absolute;
  left: 261px;
  position: absolute;
  bottom: -16px;
  z-index: 2;

  @media (max-width: 1024px) {
    left: -100px;
    bottom: inherit;
    top: -21px;
    height: 227px;
    width: 226px;
    z-index: 1;
  }
`;

const SoccerImg = styled.img`
  width: 440px;
  position: absolute;
  right: -1px;
  bottom: -16px;
  z-index: 2;

  @media (max-width: 1024px) {
    top: -21px;
    width: 266px;
    height: 227px;
    right: -2px;
  }
`;

const BlackSpace = styled.div`
  width: 550px;
  height: 334px;
  position: absolute;
  top: 30px;
  left: 1px;
  background-color: black;

  @media (max-width: 1024px) {
    top: inherit;
    bottom: 0px;
    height: 185px;
    width: 100vw;
  }
`;

const Banner = (props) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <ContentArea>
        <TitleText lineHt="30px" size="20px">
          {t('website.sponsorsSmall')}
        </TitleText>

        <BannerTextContainer>
          <Text stencil col="#fff" className="text-1">
            {t('website.ledBy')}
          </Text>

          <Text stencil col="#fff" className="text-2">
            {t('website.partners').toUpperCase()}.
          </Text>
        </BannerTextContainer>

        <TeamImg src={require('assets/images/team-placeholder.png')} />

        <SoccerImg src={require('assets/images/soccer-players.png')} />

        <BlackSpace />
      </ContentArea>
    </Wrapper>
  );
};

export default Banner;
